import React from 'react'

export default function UiHeaderWr(props) {

    return (
        <>
            <header>
                <div className='sb-top-nav-wr' >
                    <nav className="navbar  navbar-expand-xl">
                        {props.children}
                    </nav>
                </div>
            </header>
        </>
    )
}
